import type { TestAnswerFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import type { CSSProperties } from 'styled-components'
import styled from 'styled-components'

import type { ElementFeedbackCss } from 'services/Branding/types'

const FeedbackStyled = styled.div<{
  $styles: ElementFeedbackCss<TestAnswerFeedbackSchemaType>
  $type: 'success' | 'fail' | 'info'
  $typeField: 'general' | 'option'
}>`
  border-radius: ${({ $styles }) => $styles.common?.borderRadius as CSSProperties['borderRadius']};
  border-width: ${({ $styles, $type }) => $styles[$type]?.borderWidth};
  background-color: ${({ $styles, $type }) =>
    $styles[$type]?.backgroundColor as CSSProperties['backgroundColor']};
  border-style: ${({ $styles, $type }) => $styles[$type]?.borderStyle};
  border-color: ${({ $styles, $type }) =>
    $styles[$type]?.borderColor as CSSProperties['borderColor']};
  margin-top: ${({ $styles, $typeField }) =>
    $typeField === 'option' ? $styles?.indents?.marginTop : $styles?.indents?.marginBottom};
`

export default FeedbackStyled
